import React from "react";

const SIZE_CLASS = {
  sm: "rma-nc-button--sm",
  md: "rma-nc-button--md",
  lg: "rma-nc-button--lg",
};

export default function Button({
  variant = "primary",
  size = "md",
  block = false,
  className,
  disabled,
  children,
  type = "button",
  ...rest
}) {
  const classes = [
    "rma-nc-button",
    "rma-nc-button--" + variant,
    SIZE_CLASS[size],
    block ? "rma-nc-button--block" : null,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button type={type} disabled={disabled} className={classes} {...rest}>
      {children}
    </button>
  );
}
